import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Determines whether the current page can go back otherwise it will return to the provided default route
 */
export const useNavigateBackOrDefault = (replaceOnFallback = false) => {
  const navigate = useNavigate()
  const location = useLocation()
  return useCallback(
    (defaultBackLocationPath: string) => {
      if (location.key === 'default' || (replaceOnFallback && location.state?.isBackNavigationFallback)) {
        navigate(defaultBackLocationPath, {
          replace: replaceOnFallback,
          ...(replaceOnFallback && { state: { isBackNavigationFallback: true } }),
        })
      } else {
        navigate(-1)
      }
    },
    [location, navigate, replaceOnFallback],
  )
}
